import React from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker  } from "react-google-maps"
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");


const SupplierMap = withScriptjs(withGoogleMap((props) => {
    return(
        <GoogleMap
        defaultZoom={15}
        defaultCenter={{ lat: props.lat ? props.lat : -34.397, lng: props.lng ? props.lng : 150.644 }}
        >
            <InfoBox
            defaultPosition={{ lat: props.lat ? props.lat : -34.397, lng: props.lng ? props.lng : 150.644 }}>
                <div style={{backgroundColor: "#FFF", padding: "10px", display: "flex", alignItems:"center", justifyContent: "center"}}>
                    <p>{props.name && props.name}</p>
                </div>
            </InfoBox>
            <Marker
            position={{ lat: props.lat ? props.lat : -34.397, lng: props.lng ? props.lng : 150.644 }}
            />
        </GoogleMap>
    )
}))


export default SupplierMap
